import { PdfViewerService } from '@/core/services/pdf-viewer/pdf-viewer.service';
import { IconComponent } from '@/shared/components/icon/icon.component';
import { ButtonDirective } from '@/shared/directives/ui/button/button';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

/**
 * Visualiseur de document plein écran — même famille visuelle que
 * `app-lightbox`, mais pour un PDF plutôt qu'une galerie d'images, un seul
 * document à la fois.
 *
 * Le rendu passe par `ngx-extended-pdf-viewer` (pdf.js) plutôt que par le
 * lecteur du navigateur : même affichage partout, recherche, zoom, impression
 * et téléchargement intégrés. Ses fichiers (worker, polices, traductions) sont
 * copiés dans `/assets` par `angular.json`.
 *
 * Se monte une seule fois à la racine (`app.ts`) et lit `PdfViewerService` :
 * les pages n'ont qu'à appeler `pdfViewerService.open(url, label)` au lieu
 * d'un `window.open(url, '_blank')`.
 */
@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  imports: [
    IconComponent,
    NgxExtendedPdfViewerModule,
    ButtonDirective
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    '(document:keydown.escape)': 'close()',
  },
})
export class PdfViewerComponent {
  private readonly pdfViewer = inject(PdfViewerService);

  readonly doc = this.pdfViewer.document;
  readonly isOpen = computed(() => this.doc() !== null);

  close() {
    this.pdfViewer.close();
  }
}
